<template>
<div class="container">
    <div class="row d-flex justify-content-end mb-4">
        <div class="col-12 mt-3 mb-5">
            <h3 class="c-ndarkthree bold">
                <UserIcon  :color="getPrimaryColorHex.four"/>Usuários
            </h3>
            <p class="c-ndarkfour">
                Selecione a empresa que deseja visualizar ou adicionar novos usuários.
            </p>
        </div>
        <div class="col-6">
            <!-- <Tab class="mb-0 mt-0" v-model="activeTab" :items="[{ label: 'Empresas', value: '0'}, { label: 'Grupos econômicos', value: '1'}]" /> -->
            <TabUser class="mb-0 mt-0" @update-tab="activeTab = $event; pagination = 1"/>
        </div>
        <CompanyFilter
            v-if="activeTab == 0 || (activeTab == 1 && this.$store.state.user.userAdm)"
            :statusFilter="false"
            @filter="filterHandler"
            @filterSearch="filterSearchHandler"
            @emptyFilter="emptyFilterHandler"
            :companyPartnerFilter="(this.$store.state.user.userAdm)"
            :companyTypeFilter="activeTab == 0"
            :showFilterButton="!USER_TYPE_MIXIN.isBackOffice"
            :economicGroupPartnerFilter="activeTab == 1"
            ref="companyFilter"
        />
        <UserGroupFilter
        v-else-if="activeTab == 1 && !this.$store.state.user.userAdm"
            :filterSearchProp="filterQueryGroup"
            @filterSearch="filterQueryGroup = $event"
            @emptyFilter="filterQueryGroup = ''"
        />
        <UserFilter
        v-else-if="activeTab == 2"
            @filterStatus="filterStatus = $event; paginationNextAndPrev(1)"
            @filterSearch="filterSearch = $event; paginationNextAndPrev(1)"
            @emptyFilter="filterStatus = $event; paginationNextAndPrev(1)"
            :withEmail="true"
        />

    </div>
    <div class="row pt-2">
        <div class="col-12" v-if="activeTab == 0">
            <TableLoading v-if="isLoading" rowHeight="56" :tableHeader="false"/>
            <CompanyUser :tableData="$store.state.companies.companies" v-else-if="$store.state.companies.companies.length" @persistFilter="persistFilter"/>
            <NotFound v-else/>
        </div>
        <div class="col-12" v-if="activeTab == 1">
            <TableLoading v-if="isLoading" rowHeight="56" :tableHeader="false"/>
            <GroupUser :tableData="filteredGroupTableData" v-if="filteredGroupTableData.length" @persistFilter="persistFilter"/>
            <NotFound v-else/>
        </div>
        <div class="col-12" v-if="activeTab == 2">
            <AllUsers :tableData="filteredUsersTableData" v-if="filteredUsersTableData.length" @persistFilter="persistFilter"/>
            <NotFound v-else/>
        </div>
    </div>
    <PaginationButtons v-if="activeTab == 0 && $store.state.companies.companies.length > 0" :pagination="$store.state.companies.companiesPagination" @next="paginationNextAndPrev($event)" @prev="paginationNextAndPrev($event)"/>
    <PaginationButtons v-if="activeTab == 2 && filteredUsersTableData.length > 0" :pagination="$store.state.user.usersPagination" @next="paginationNextAndPrev($event)" @prev="paginationNextAndPrev($event)"/>
</div>
</template>

<script>
import UserIcon from '@/components/icons/Users'
import PaginationButtons from '@/components/pagination/PaginationButtons'
import CompanyUser from '@/components/tables/CompanyUser'
import AllUsers from '@/components/tables/AllUsers'
import GroupUser from '@/components/tables/GroupUser'
import UserGroupFilter from '@/components/filters/UserGroupFilter'
import UserFilter from '@/components/filters/UserFilter'
import getCompanies from '@/api/getCompanies'
import NotFound from '@/components/emptyOrNotFound/NotFound.vue'
import getAllEconomicGroups from  '@/api/getAllEconomicGroups'
import TabUser from '@/components/tabs/TabUser'
import removeDotsAndBars from '@/utils/removeDotsAndBars'
import TableLoading from '@/components/loading/TableLoading'
import store from '@/store'
import getAllUsers from  '@/api/getAllUsers'
import CompanyFilter from '@/components/filters/CompanyFilter'


export default {
    components: {
        PaginationButtons,
        UserIcon,
        CompanyUser,
        UserGroupFilter,
        GroupUser,
        NotFound,
        TabUser,
        AllUsers,
        UserFilter,
        TableLoading,
        CompanyFilter
    },
    data() {
        return {
            filterCompanyType: '',
            filterQuery: '',
            filterQueryGroup: '',
            filterSearch: '',
            filterCompanyPartner: '',
            filterStatus: {
                accessLevel: '',
                registerSituation: ''
            },
            activeTab: '',
            statusOptions: [{ label: 'Comprador', value: '2'}, { label: 'Fornecedor', value: '1'}, { label: 'Financiador', value: '0'}],
            dataTableGroup: [
                {
                    name: 'Perfumaria Sumirê',
                    cnpj: {
                        companyType: 'Comprador'
                    }
                },
                {
                    name: 'Perfumaria Sumirê',
                    cnpj: {
                        companyType: 'Comprador'
                    }
                },
                {
                    name: 'Perfumaria Sumirê',
                    cnpj: {
                        companyType: 'Comprador'
                    }
                }
            ],
            isLoading: false,
            pagination: 1
        }
    },
    watch: {
        activeTab(val) {
            if (val == '2') {
                this.requestUsers()
            } else if (val == '1') {
                if (this.$refs.companyFilter) this.$refs.companyFilter.emptyFilters()
                this.requestEconomicGroups()
            } else {
                if (this.$refs.companyFilter) this.$refs.companyFilter.emptyFilters()
                this.requestCompanies()
            }
        },
        pagination(val) {
            this.$store.commit('pages/setUsers', parseInt(val))
        }
    },
    computed: {
        filteredGroupTableData() {
            return this.$store.state.group.groups
                .filter(group => group.name.toLowerCase().includes(this.filterQueryGroup.toLowerCase()))
                .filter(group => {
                    if (this.filterCompanyPartner === '') return true
                    return (group.partnerId == this.filterCompanyPartner)
                })
        },
        filteredUsersTableData() {
            return this.$store.state.user.allUsers
        },
    },
    methods: {
        persistFilter() {
            this.$store.commit('filters/setPersistentFilterCompanyType', this.filterCompanyType)
            this.$store.commit('filters/setPersistentFilterQuery', this.filterQuery)
            this.$store.commit('filters/setPersistentFilterQueryGroup', this.filterQueryGroup)
            this.$store.commit('filters/setPersistentFilterPartner', this.filterCompanyPartner)
        },
        async requestEconomicGroups() {
            this.isLoading = true
            await getAllEconomicGroups({ page: this.pagination,
                query: this.filterQueryGroup,
                partner: this.filterCompanyPartner,
                withBuyer: true,
                requiredBuyer: this.$route.path.includes('user'),
            })
            this.isLoading = false
        },
        async requestCompanies() {
            this.isLoading = true
            // TODO: Alterar parâmetros da função para objeto
            await getCompanies({
                page: this.pagination,
                companyType: this.USER_TYPE_MIXIN.isBackOffice ? null : this.filterCompanyType,
                query: removeDotsAndBars(this.filterQuery),
                partner: this.filterCompanyPartner,
                noBuyer: this.$route.path.includes('user'),
            });
            this.isLoading = false
        },
        async requestUsers() {
            const { accessLevel, registerSituation } = this.filterStatus

            await getAllUsers({
                page: this.pagination,
                emailChecked: registerSituation,
                accessLevel,
                query: this.filterSearch
            })
        },
        async paginationNextAndPrev(page) {
            this.isLoading = true
            this.pagination = page
            if (this.activeTab == 0) {
                await getCompanies({
                    page,
                    companyType: this.USER_TYPE_MIXIN.isBackOffice ? null : this.filterCompanyType,
                    query: removeDotsAndBars(this.filterQuery),
                    partner: this.filterCompanyPartner,
                    noBuyer: this.$route.path.includes('user'),
                });
            } else if (this.activeTab == 1){
                await getAllEconomicGroups({ 
                    page: this.pagination,
                    query: this.filterQueryGroup,
                    partner: this.filterCompanyPartner,
                    withBuyer: true,
                    requiredBuyer: this.$route.path.includes('user'),
                });
            } else if (this.activeTab == 2){
                await this.requestUsers()
            }
            this.isLoading = false
        },
        emptyFilter(tab) {
            if (tab === 0) {
                this.filterCompanyType = '',
                this.filterQuery = '',
                this.filterCompanyPartner = ''
            }
            if (tab === 1) {
                this.filterQueryGroup = '',
                this.filterCompanyPartner = ''
            }
        },
        filterSearchHandler($event) {
            if (this.activeTab == 0) {
                this.filterQuery = $event
                this.paginationNextAndPrev(1)
            }

            if (this.activeTab == 1) {
                this.filterQueryGroup = $event
            }
        },
        emptyFilterHandler() {
            if (this.activeTab == 0) {
                this.emptyFilter(0)
                this.paginationNextAndPrev(1)
            }

            if (this.activeTab == 1) {
                this.emptyFilter(1)
                this.paginationNextAndPrev(1)
            }
        },
        filterHandler($event) {
            if (this.activeTab == 0) {
                this.filterCompanyType = $event.companyType
                this.filterCompanyPartner = $event.companyPartner
                this.paginationNextAndPrev(1)
            }

            if (this.activeTab == 1) {
                this.filterCompanyPartner = $event.companyPartner
            }
        }
    },
    beforeRouteEnter (to, from, next) {
        store.commit('filters/setBeforePathEnter', from.path)
        next();
    },
    async created() {
        const { state: { 
                filters: { persistentFilterCompanyType, persistentFilterQueryGroup, persistentFilterQuery, persistentFilterPartner,beforePathEnter },
        } } = this.$store
        const usersPath = "/user/company/"
        const groupPath = "/user/group/"
        const cameFromUser = (beforePathEnter.includes(groupPath) || beforePathEnter.includes(usersPath))

        if (cameFromUser) {
            this.filterCompanyType = persistentFilterCompanyType
            this.filterQuery = persistentFilterQuery
            this.filterQueryGroup = persistentFilterQueryGroup
            this.filterCompanyPartner = persistentFilterPartner
            this.pagination = this.$store.state.pages.users
        } else {
            this.$store.commit('filters/setPersistentFilterCompanyType', '')
            this.$store.commit('filters/setPersistentFilterQuery', '')
            this.$store.commit('filters/setPersistentFilterQueryGroup', '')
            this.$store.commit('filters/setPersistentFilterPartner', '')
            this.pagination = 1
        }

        if (this.USER_TYPE_MIXIN.isBackOffice) this.$store.commit('tabs/setUserTab', 0)
        this.activeTab = this.$store.state.tabs.userTab
    }

}
</script>

<style lang="scss" scoped>
</style>
